import { FormControlProps } from 'parkdepot-shared/components/FormControl'

export const FormControlOverrides: FormControlProps['overrides'] = {
    ControlContainer: {
        style: {
            marginBottom: 0
        }
    },
    LabelContainer: {
        style: {
            marginTop: 0
        }
    },
    Label: {
        style: ({ $theme }) => ({
            ...$theme.typography.ParagraphXSmall,
            lineHeight: '150%',
            color: $theme.colors.mono400
        })
    },
    Caption: {
        style: ({ $theme }) => ({
            ...$theme.typography.ParagraphXSmall,
            color: $theme.colors.primaryA,
            marginBottom: 0
        })
    }
}
